import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sidebar-bottom"
}
const _hoisted_2 = { class: "hr-ltcs-request-btn__main" }
const _hoisted_3 = { class: "hr-ltcs-request-btn__status hr-ltcs-request-btn__status--multi" }
const _hoisted_4 = {
  key: 0,
  class: "status-sep"
}
const _hoisted_5 = { class: "status-label" }

import { ref, computed, watch, onUnmounted } from 'vue';
import LtcsHrRequestModal from '@/components/member/request/LtcsHrRequestModal.vue';
import {
  HR_LTCS_REQUEST_TYPES,
  WAGE_LTCS_REQUEST_TYPES,
  fetchLtcsTypeStatuses,
  aggregateLtcsBtnStatus,
  type LtcsRequestBtnStatus,
  type LtcsTypeStatusItem,
} from '@/composables/useLtcsMacroRequest';
import { isLtcsMacroBizGubun } from '@/constants/ltcsMacro';


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsRequestSidebarButton',
  props: {
    memberCode: {},
    bizGubun: {},
    yearMonth: {},
    variant: { default: 'hr' }
  },
  emits: ["updated", "ready"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showModal = ref(false);
const typeStatuses = ref<LtcsTypeStatusItem[]>([]);
const prevStatusByType = ref<Record<string, LtcsRequestBtnStatus>>({});
let statusPolling: ReturnType<typeof setInterval> | null = null;

const allowedTypes = computed(() =>
  props.variant === 'wage' ? WAGE_LTCS_REQUEST_TYPES : HR_LTCS_REQUEST_TYPES
);

const showLtcsRequest = computed(() => isLtcsMacroBizGubun(props.bizGubun));

const btnStatus = computed(() => aggregateLtcsBtnStatus(typeStatuses.value));

const getStatusDotClass = (status: LtcsRequestBtnStatus) => {
  if (status === 'ready') return ['status-dot--ready'];
  if (status === 'processing') return ['status-dot--processing', 'status-dot--pulse'];
  return ['status-dot--bad'];
};

const emitReadyIfNeeded = (prev: Record<string, LtcsRequestBtnStatus>) => {
  const anyNewReady = typeStatuses.value.some(
    (item) =>
      item.status === 'ready' &&
      prev[item.type] !== undefined &&
      prev[item.type] !== 'ready'
  );
  if (anyNewReady) {
    emit('ready');
  }
};

const loadBtnStatus = async () => {
  const prev = { ...prevStatusByType.value };

  typeStatuses.value = await fetchLtcsTypeStatuses(
    props.memberCode,
    props.bizGubun,
    props.yearMonth,
    allowedTypes.value
  );

  const nextMap: Record<string, LtcsRequestBtnStatus> = {};
  typeStatuses.value.forEach((item) => {
    nextMap[item.type] = item.status;
  });
  prevStatusByType.value = nextMap;
  emitReadyIfNeeded(prev);
};

const stopStatusPolling = () => {
  if (statusPolling) {
    clearInterval(statusPolling);
    statusPolling = null;
  }
};

const startStatusPolling = () => {
  if (statusPolling) return;
  statusPolling = setInterval(async () => {
    await loadBtnStatus();
    if (btnStatus.value !== 'processing') {
      stopStatusPolling();
    }
  }, 4000);
};

const onModalUpdated = async () => {
  await loadBtnStatus();
  emit('updated');

  if (btnStatus.value === 'processing') {
    startStatusPolling();
  }
};

watch(
  () => [props.memberCode, props.bizGubun, props.yearMonth, props.variant] as const,
  () => {
    loadBtnStatus();
  },
  { immediate: true }
);

watch(btnStatus, (status) => {
  if (status === 'processing') {
    startStatusPolling();
  }
});

onUnmounted(() => {
  stopStatusPolling();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showLtcsRequest.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["hr-ltcs-request-btn", btnStatus.value ? `hr-ltcs-request-btn--${btnStatus.value}` : undefined]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, { size: "14" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-cloud-download-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "롱텀케어 자료요청", -1))
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStatuses.value, (item, idx) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: item.type,
                  class: "status-item"
                }, [
                  (idx > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "/"))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["status-dot", getStatusDotClass(item.status)])
                  }, null, 2),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
                ]))
              }), 128))
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createVNode(LtcsHrRequestModal, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
      "member-code": __props.memberCode,
      "biz-gubun": __props.bizGubun,
      "year-month": __props.yearMonth,
      "allowed-types": allowedTypes.value,
      onUpdated: onModalUpdated
    }, null, 8, ["modelValue", "member-code", "biz-gubun", "year-month", "allowed-types"])
  ], 64))
}
}

})